import { render, staticRenderFns } from "./hero-panel.vue?vue&type=template&id=31299c8c"
import script from "./hero-panel.vue?vue&type=script&lang=js"
export * from "./hero-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports